(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["SN-home-hero"] && !window.DesignMode) return;
  try {
    
	$("body").addClass("slide-color-light has-slideshow-full-window");
	$(".home-email input").focus();	

  } catch(e) { console.error(e); }
})();

})();
